function EmptyIcon({ width = 250, height = 250, className = '' }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1600.000000 1600.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g transform="translate(0.000000,1600.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M7380 13469 c-469 -10 -920 -27 -1300 -50 -179 -10 -351 -19 -383
-19 -64 0 -165 -35 -205 -73 -14 -12 -40 -46 -59 -75 l-34 -53 -10 -177 c-6
-101 -16 -190 -24 -208 -17 -39 -32 -41 -348 -50 -144 -5 -233 -11 -243 -19
-12 -8 -20 -57 -34 -210 -25 -277 -59 -480 -120 -725 -11 -41 -22 -91 -26
-110 -4 -19 -12 -48 -20 -65 -21 -49 -94 -285 -94 -304 0 -23 28 -47 60 -53
14 -3 66 -18 115 -33 201 -61 465 -105 629 -105 52 0 67 -4 75 -17 9 -18 11
-39 36 -468 8 -137 18 -270 21 -295 17 -133 108 -229 235 -249 35 -5 143 -13
239 -16 96 -3 281 -10 410 -15 129 -6 479 -15 778 -20 340 -6 551 -14 563 -20
18 -10 19 -21 17 -223 l-3 -212 -25 -7 c-14 -4 -70 -15 -125 -24 -55 -9 -127
-26 -160 -38 -60 -21 -66 -21 -1134 -24 l-1074 -3 -56 63 c-136 153 -225 238
-247 238 -13 0 -76 -14 -141 -31 -65 -17 -176 -46 -248 -64 -71 -19 -215 -57
-320 -85 -104 -29 -255 -70 -335 -91 -80 -21 -156 -43 -170 -48 -14 -5 -61
-19 -105 -31 -182 -50 -244 -76 -245 -103 0 -4 62 -70 138 -145 117 -116 253
-277 269 -317 3 -10 -19 -40 -142 -190 -142 -172 -472 -652 -656 -953 -100
-164 -198 -327 -222 -372 -16 -30 -36 -62 -43 -71 -8 -8 -14 -20 -14 -25 0 -5
-16 -36 -36 -69 -35 -58 -71 -121 -121 -215 -13 -25 -41 -77 -62 -116 -21 -40
-58 -109 -83 -155 -194 -359 -558 -1092 -688 -1384 -12 -27 -37 -81 -55 -120
-18 -38 -47 -104 -65 -145 -17 -41 -37 -88 -45 -105 -34 -79 -54 -126 -80
-190 -16 -38 -32 -74 -37 -79 -4 -6 -8 -16 -8 -24 0 -8 -7 -28 -15 -45 -8 -18
-36 -86 -62 -152 l-48 -120 0 -165 c1 -173 9 -223 67 -385 56 -157 193 -322
304 -366 58 -23 67 -24 444 -27 242 -2 389 -7 397 -14 7 -5 26 -55 43 -111 18
-56 38 -118 45 -137 19 -50 44 -126 61 -190 9 -30 19 -59 24 -65 4 -5 12 -26
18 -45 21 -78 115 -316 131 -333 18 -19 46 -15 55 8 4 11 -52 178 -85 250 -11
27 -37 99 -54 155 -22 70 -45 142 -60 180 -42 111 -87 270 -81 287 4 10 69 13
340 13 307 0 334 -1 340 -17 10 -25 70 -371 112 -648 15 -99 32 -186 37 -192
17 -23 56 -16 63 11 3 14 3 29 0 34 -3 5 -17 81 -30 168 -13 88 -41 261 -62
385 -20 125 -34 234 -31 243 6 15 373 16 4756 16 4351 0 4749 -1 4755 -16 8
-21 -45 -308 -104 -559 -57 -243 -55 -227 -34 -242 35 -26 56 4 80 113 11 54
33 151 47 214 24 107 48 227 77 393 7 37 19 75 27 83 12 12 72 14 364 14 l349
0 0 -30 c0 -17 -4 -38 -9 -48 -5 -9 -24 -64 -41 -122 -18 -58 -38 -121 -45
-140 -12 -32 -118 -362 -145 -453 -15 -47 -7 -69 22 -65 32 4 54 52 108 238
25 84 48 156 65 200 12 31 92 283 111 350 4 14 14 35 22 48 l14 22 312 0 c182
0 337 5 372 11 83 15 146 53 219 131 65 71 148 221 181 328 42 136 55 320 33
449 -13 73 -22 94 -237 541 -69 145 -405 817 -505 1010 -133 259 -354 679
-407 775 -15 28 -45 84 -67 125 -22 41 -57 107 -79 145 -21 39 -51 93 -66 120
-15 28 -31 57 -35 65 -4 8 -19 35 -33 61 -27 44 -70 120 -97 169 -8 14 -25 43
-39 65 -13 22 -27 47 -31 55 -6 13 -105 176 -133 220 -5 8 -20 32 -32 54 -33
56 -41 68 -64 101 -12 17 -23 35 -25 40 -4 11 -101 160 -161 249 -22 32 -68
99 -102 150 -33 50 -65 96 -71 103 -5 6 -20 27 -33 45 -27 39 -204 277 -247
332 -43 55 -87 109 -192 232 -50 60 -120 145 -155 189 -91 115 -258 240 -347
262 -14 3 -31 10 -37 15 -7 5 -43 16 -80 25 -60 14 -177 17 -914 22 l-845 6
-100 51 c-55 29 -122 59 -150 69 -27 9 -57 21 -66 25 -42 22 -232 61 -342 71
-138 12 -327 -1 -412 -27 -119 -38 -239 -89 -297 -128 -29 -19 -45 -19 -168 3
-35 7 -70 17 -77 23 -16 13 -19 409 -3 437 8 16 36 19 322 25 695 15 1596 60
1708 83 71 16 78 20 140 82 52 53 67 76 78 116 13 53 32 317 32 448 0 43 4 87
10 97 12 23 61 48 120 61 24 6 58 16 75 24 16 7 44 16 60 20 17 4 44 12 60 20
17 7 50 18 75 25 25 7 50 16 55 20 6 4 27 10 47 14 42 8 68 37 68 78 0 15 -26
107 -59 205 -32 98 -62 194 -65 213 -4 19 -14 56 -23 83 -8 26 -18 105 -21
175 -7 126 -7 127 -32 131 -24 3 -162 -26 -262 -55 -76 -23 -75 -25 -82 174
-10 285 -34 705 -52 919 -12 151 -21 210 -37 248 -38 90 -113 152 -212 174
-65 14 -591 38 -1115 51 -457 11 -1152 11 -1670 -1z m808 -232 c7 -8 15 -185
23 -482 20 -758 -16 -2403 -54 -2462 -10 -16 -1021 -18 -1437 -3 -650 23 -815
32 -860 47 -56 20 -112 76 -127 129 -11 36 -34 301 -50 566 -5 87 -3 108 8
112 8 3 62 10 121 15 161 16 268 46 319 89 38 33 48 36 108 37 36 1 194 8 351
15 157 7 493 14 748 15 352 1 466 5 475 14 24 24 -20 39 -141 47 -240 15
-1271 -11 -1400 -36 -71 -13 -81 2 -54 77 22 58 65 226 78 295 3 20 13 40 22
43 45 18 361 37 706 44 336 6 370 11 314 43 -40 23 -800 9 -967 -18 -52 -8
-54 1 -36 156 8 69 15 151 15 182 0 45 5 61 20 76 23 21 68 24 712 42 397 11
488 18 514 37 19 14 19 14 -1 29 -16 12 -39 14 -105 9 -47 -3 -197 -10 -335
-16 -557 -24 -708 -34 -743 -51 -42 -21 -49 2 -55 174 -7 207 -27 190 258 208
118 7 241 13 273 15 31 1 80 5 107 9 28 3 158 13 290 21 272 17 308 23 313 49
6 28 -16 35 -83 30 -264 -20 -471 -37 -590 -49 -150 -15 -337 -26 -475 -29
l-85 -1 -13 30 c-7 17 -18 41 -25 55 l-13 25 -234 0 c-129 0 -269 -2 -310 -5
l-75 -5 3 85 c2 47 10 106 18 132 20 61 87 123 144 132 154 24 1064 66 1660
75 256 4 508 8 561 9 68 2 100 -2 107 -11z m877 -8 c567 -16 851 -32 900 -53
80 -34 108 -76 123 -186 23 -160 58 -717 47 -729 -4 -3 -420 -6 -926 -6 -916
-1 -920 0 -924 20 -9 48 -16 947 -6 958 11 14 187 13 786 -4z m-2785 -484 c17
-21 18 -452 1 -635 -30 -332 -83 -591 -154 -751 -37 -81 -71 -98 -252 -123
-443 -62 -808 -39 -1192 77 -72 21 -104 36 -108 48 -4 10 19 89 49 175 31 86
56 163 56 172 0 8 8 45 19 81 54 192 97 486 106 720 4 85 8 158 10 161 2 4 93
10 202 14 109 3 259 13 333 21 74 7 209 21 300 29 91 9 181 18 200 19 19 2
121 5 226 5 161 2 194 0 204 -13z m2619 -554 c11 -7 15 -81 20 -367 4 -207 3
-368 -2 -380 -12 -28 -71 -33 -386 -35 -189 -1 -235 1 -242 12 -14 23 -11 753
3 767 14 14 584 17 607 3z m1241 -11 c5 -8 10 -95 10 -193 l0 -177 -26 -11
c-15 -5 -68 -19 -118 -30 -105 -23 -151 -42 -161 -66 -4 -10 -10 -70 -12 -133
-3 -63 -9 -119 -13 -124 -13 -13 -100 -17 -471 -22 -301 -4 -338 -3 -353 11
-13 14 -16 41 -16 158 0 78 -5 241 -11 361 -5 120 -8 225 -5 233 5 11 101 13
586 11 503 -3 582 -5 590 -18z m633 -307 c3 -5 10 -59 16 -122 11 -103 25
-163 81 -346 11 -33 26 -85 35 -115 9 -30 20 -62 24 -70 5 -9 12 -30 15 -47 6
-25 3 -34 -11 -41 -20 -11 -340 -120 -388 -133 -16 -4 -131 -41 -253 -83 -173
-58 -228 -73 -243 -66 -19 11 -33 38 -69 135 -12 33 -26 67 -30 76 -5 9 -21
63 -36 120 -26 95 -28 119 -28 285 -1 195 4 214 50 214 27 0 221 48 246 62 10
4 37 13 60 18 24 5 140 33 258 64 213 54 264 63 273 49z m-1263 -508 c11 -13
8 -81 -14 -373 -15 -196 -33 -424 -39 -506 -10 -135 -13 -149 -31 -156 -37
-14 -1165 -54 -1178 -42 -4 4 -3 77 2 162 5 85 14 322 20 525 6 204 15 373 19
377 4 4 187 8 406 9 220 1 409 6 420 10 11 4 102 8 201 8 152 1 184 -2 194
-14z m319 -22 c6 -21 11 -52 11 -69 0 -32 31 -156 68 -272 20 -60 20 -63 2
-72 -10 -6 -40 -10 -67 -10 -26 -1 -95 -7 -153 -14 -58 -7 -109 -11 -113 -9
-4 3 -5 104 -1 226 5 178 10 226 22 240 13 14 32 17 118 17 l103 0 10 -37z
m167 -524 c22 -23 36 -29 71 -29 29 0 46 -5 49 -14 3 -8 1 -71 -4 -140 -11
-147 -30 -194 -96 -244 l-44 -33 -204 -13 c-111 -7 -209 -11 -216 -8 -11 4
-13 24 -8 91 3 47 8 150 12 227 3 78 9 146 13 151 3 6 84 18 180 27 96 9 176
18 178 20 9 9 43 -8 69 -35z m-5085 -1166 c82 -84 217 -253 253 -318 9 -16 26
-46 38 -65 138 -231 219 -471 269 -795 15 -97 12 -428 -5 -540 -21 -141 -27
-157 -96 -238 -34 -40 -80 -94 -103 -121 -23 -27 -55 -63 -70 -80 -16 -17 -53
-62 -82 -101 -69 -93 -87 -107 -175 -148 -246 -115 -724 -225 -1061 -244 -122
-7 -140 2 -91 45 38 35 81 95 109 152 47 97 71 156 78 187 4 18 11 35 16 38 5
4 9 17 9 31 0 13 10 62 22 107 21 75 23 103 23 342 0 235 -3 269 -23 354 -23
96 -57 210 -72 246 -40 92 -70 164 -70 168 0 10 -99 177 -156 262 -61 92 -176
226 -283 330 -33 33 -61 65 -61 71 0 12 30 22 250 85 149 42 302 86 365 104
28 8 111 31 185 50 74 20 169 46 210 57 41 11 118 31 170 45 52 14 124 33 160
43 36 9 74 18 85 19 13 1 51 -30 106 -86z m4374 -8 c149 -34 193 -50 350 -126
117 -56 202 -107 300 -182 98 -74 241 -212 303 -292 25 -33 49 -62 52 -65 22
-18 119 -180 165 -274 57 -118 80 -176 96 -241 5 -22 17 -71 27 -110 13 -54
17 -113 17 -255 0 -173 -2 -191 -29 -285 -26 -91 -82 -212 -127 -277 -118
-167 -294 -286 -519 -354 -91 -27 -103 -29 -300 -28 -190 0 -213 2 -315 27
-60 16 -124 35 -142 43 -17 7 -36 14 -43 14 -17 0 -229 104 -273 134 -21 14
-40 26 -43 26 -17 0 -212 157 -293 234 -95 93 -271 307 -271 331 0 3 -15 28
-34 57 -29 46 -54 99 -111 233 -20 47 -51 171 -70 278 -20 112 -16 320 9 417
27 108 49 174 67 204 10 17 19 37 19 43 0 20 96 152 154 211 90 93 293 210
397 227 24 4 53 12 63 18 66 34 386 30 551 -8z m-2215 -205 c12 -8 7 -17 -29
-52 -51 -50 -62 -74 -70 -148 l-6 -55 -725 -5 c-399 -3 -736 -10 -750 -15 -14
-4 -42 -19 -63 -32 -21 -13 -43 -23 -49 -21 -5 2 -32 46 -59 98 -28 52 -65
114 -83 140 -41 57 -47 75 -33 89 14 14 1844 16 1867 1z m4366 -1 c100 -11
190 -40 283 -91 106 -58 181 -127 276 -252 29 -39 68 -87 85 -106 52 -57 143
-168 234 -285 48 -60 91 -116 96 -122 6 -7 31 -43 57 -80 26 -38 61 -86 79
-108 36 -46 324 -472 324 -481 0 -3 10 -20 23 -37 12 -18 28 -41 34 -52 24
-40 75 -122 129 -210 52 -84 175 -292 223 -377 11 -21 29 -53 39 -70 11 -18
35 -62 54 -98 19 -36 44 -81 55 -100 51 -91 79 -141 115 -210 22 -41 56 -104
76 -140 33 -61 91 -172 206 -390 175 -334 601 -1181 754 -1500 33 -69 83 -172
111 -230 55 -115 71 -169 71 -245 0 -81 -21 -147 -76 -247 -21 -39 -110 -114
-169 -142 -27 -14 -85 -29 -128 -35 -115 -16 -12656 -15 -12764 0 -221 33
-373 206 -373 428 0 71 27 172 56 216 8 11 14 26 14 34 0 8 8 33 18 55 10 23
29 68 42 101 13 33 31 78 41 100 10 22 38 90 64 150 25 61 55 128 66 151 10
23 19 44 19 47 0 4 21 50 46 104 25 54 59 127 75 163 66 144 124 262 342 699
222 442 266 528 346 676 20 39 59 111 86 160 27 50 57 104 67 120 10 17 22 41
28 54 6 13 36 67 68 120 31 53 60 103 64 112 7 17 188 320 254 426 22 34 63
101 93 150 64 103 255 388 271 403 3 3 14 19 24 35 27 43 299 402 339 448 38
44 57 42 82 -6 9 -18 25 -48 37 -67 11 -19 36 -71 55 -115 19 -44 38 -89 43
-100 19 -40 60 -179 66 -219 3 -23 13 -63 22 -91 23 -68 25 -513 3 -590 -19
-68 -32 -81 -99 -93 -31 -6 -93 -19 -137 -27 -44 -9 -132 -23 -195 -31 -254
-31 -250 -30 -250 -84 0 -53 22 -158 46 -222 31 -82 97 -159 168 -195 50 -26
55 -27 231 -25 161 1 245 8 465 42 128 19 404 81 436 98 11 5 44 15 74 22 30
7 60 16 65 20 6 4 28 13 50 20 22 7 46 17 53 23 22 18 27 -3 7 -36 -10 -18
-48 -68 -85 -112 -208 -248 -389 -498 -419 -575 -37 -96 -42 -135 -39 -280 3
-128 7 -150 27 -190 29 -57 79 -110 103 -110 36 0 30 -30 -23 -112 -75 -117
-99 -190 -106 -323 -7 -130 9 -275 37 -338 28 -63 97 -136 145 -154 81 -30
173 -53 275 -68 58 -9 134 -22 170 -30 36 -7 121 -23 190 -35 132 -23 295 -52
420 -75 83 -16 282 -46 495 -75 426 -58 797 -89 1165 -96 319 -7 449 3 572 42
65 21 136 100 234 259 55 91 495 961 563 1115 18 41 48 107 66 145 18 39 45
99 60 135 47 108 48 109 209 117 128 6 140 5 152 -12 8 -10 14 -33 14 -49 0
-17 7 -65 16 -106 8 -41 19 -102 23 -135 15 -111 104 -551 142 -700 69 -271
100 -388 114 -425 7 -19 23 -63 35 -98 40 -111 135 -249 193 -279 55 -28 278
-35 942 -28 606 6 840 13 1070 35 55 5 163 14 240 20 231 18 314 37 329 75 15
40 2 96 -76 335 -27 81 -25 98 12 176 38 77 70 113 110 121 17 3 44 19 61 35
25 26 29 37 29 88 0 73 3 75 130 83 190 12 229 59 174 210 -8 23 -30 94 -49
159 -33 110 -34 118 -21 156 26 72 93 161 122 162 26 0 76 34 89 61 13 24 14
43 4 121 -6 51 -14 100 -19 108 -4 8 -13 40 -20 70 -6 30 -18 73 -25 95 -7 22
-25 81 -41 130 -15 50 -31 94 -36 100 -4 5 -8 15 -8 22 0 15 -64 187 -80 215
-6 10 -10 23 -10 29 0 5 -11 35 -25 64 -13 30 -27 66 -31 80 -3 14 -10 28 -15
31 -5 3 -9 12 -9 21 0 9 -11 39 -24 67 -14 28 -31 67 -39 86 -83 201 -177 405
-310 673 -102 204 -126 246 -173 292 -30 30 -59 55 -65 55 -6 0 -25 6 -42 14
-36 16 -301 40 -626 57 -119 6 -226 16 -239 22 -24 11 -62 63 -277 377 -72
106 -109 146 -160 173 -62 33 -81 37 -217 45 l-126 8 -90 85 c-49 47 -110 99
-136 115 -46 29 -57 48 -33 57 25 11 1408 7 1503 -4z m-4321 -329 c112 -17
601 -41 823 -40 25 0 4 -87 -30 -120 -15 -15 -483 -14 -1755 5 -314 5 -377 3
-401 -9 -20 -10 -44 -46 -88 -133 -34 -65 -64 -131 -68 -148 -9 -37 -49 -124
-57 -125 -8 0 -19 63 -19 105 0 38 -74 287 -101 338 -14 28 -17 43 -9 57 11
21 68 58 108 70 38 12 1524 12 1597 0z m3328 -1 c84 -21 118 -54 243 -239 24
-36 60 -87 79 -115 91 -127 108 -156 98 -166 -7 -7 -57 -8 -147 -3 l-137 7
-63 126 c-70 141 -130 239 -200 324 -26 32 -44 62 -41 67 8 13 116 13 168 -1z
m-3535 -205 c942 -7 983 -8 993 -26 13 -24 -6 -97 -27 -105 -9 -3 -400 -6
-869 -7 -469 -1 -857 -5 -862 -9 -4 -5 1 -15 12 -23 17 -13 91 -15 510 -13
270 2 496 -1 504 -5 25 -16 -7 -28 -94 -37 -100 -10 -226 -42 -375 -96 -103
-37 -107 -37 -240 -35 -584 8 -826 14 -833 21 -8 8 10 61 45 129 l23 42 210 1
c115 1 196 4 179 8 -17 4 -37 12 -45 17 -8 5 -79 11 -159 14 l-145 5 -3 26
c-2 15 4 33 12 42 9 9 16 22 16 29 0 32 23 40 95 34 39 -3 512 -9 1053 -12z
m965 -190 c15 -5 17 -15 15 -57 -3 -51 -4 -52 -33 -51 -16 1 -61 12 -100 23
-88 27 -145 39 -258 51 -50 6 -97 14 -106 19 -15 9 -10 11 79 24 35 6 381 -3
403 -9z m-555 -11 c-21 -2 -55 -2 -75 0 -21 2 -4 4 37 4 41 0 58 -2 38 -4z
m143 -98 c92 -13 160 -28 344 -79 70 -19 102 -51 110 -112 6 -46 47 -195 65
-239 49 -117 66 -154 82 -177 10 -14 18 -31 18 -36 0 -6 8 -23 17 -39 16 -28
15 -34 -15 -145 -92 -332 -178 -754 -206 -1003 -3 -27 -15 -126 -27 -220 -11
-93 -19 -190 -17 -214 2 -29 -1 -46 -9 -48 -7 -3 -36 18 -65 45 -62 58 -160
129 -238 172 -30 17 -62 34 -70 40 -61 38 -279 114 -420 145 -243 55 -651 59
-965 10 -156 -24 -231 -38 -253 -46 -40 -15 -56 -4 -48 33 3 17 12 39 19 47 8
9 26 45 42 81 15 36 52 116 82 179 29 62 53 115 53 117 0 2 14 34 31 71 48
106 149 334 149 338 0 2 16 39 35 82 20 43 40 87 45 98 5 11 18 40 28 65 53
124 182 415 235 532 35 75 90 141 138 165 82 40 179 74 298 104 192 49 364 59
542 34z m3419 -95 c129 -5 312 -14 405 -20 590 -36 580 -33 644 -134 44 -71
195 -368 266 -526 52 -116 84 -186 97 -213 5 -10 31 -71 59 -135 28 -64 56
-130 64 -147 7 -16 29 -68 48 -115 19 -47 40 -98 47 -115 7 -16 16 -39 21 -50
4 -11 22 -58 39 -105 18 -47 38 -98 45 -115 8 -16 19 -50 25 -74 6 -24 16 -51
21 -60 10 -18 76 -269 91 -344 7 -39 6 -54 -6 -72 -18 -27 -43 -32 -216 -40
-69 -3 -258 -12 -420 -20 -1053 -52 -1677 -76 -1737 -68 -68 8 -119 37 -148
83 -32 51 -32 64 7 135 l31 58 -12 91 c-7 50 -21 143 -31 206 -10 63 -26 160
-35 215 -9 55 -21 129 -26 165 l-9 65 47 43 c26 23 55 42 64 42 8 0 100 -89
203 -197 320 -337 538 -553 563 -559 61 -16 185 52 217 119 24 52 21 110 -8
144 -14 15 -182 187 -375 382 -204 205 -351 361 -351 372 0 10 20 58 44 106
95 191 126 417 91 673 -7 58 -21 124 -29 148 -17 47 -12 72 13 72 9 0 122 -4
251 -10z m-4493 -16 c39 -3 79 -11 88 -18 16 -12 16 -14 -7 -37 -14 -13 -31
-40 -38 -59 -8 -19 -28 -62 -45 -95 l-31 -60 -386 -3 -386 -2 -10 32 c-11 37
-24 243 -15 251 6 7 727 -1 830 -9z m-139 -507 c2 -10 -9 -46 -25 -80 -16 -34
-40 -88 -54 -121 -14 -35 -32 -61 -44 -65 -11 -4 -99 -2 -195 5 -96 7 -226 13
-288 13 -92 1 -114 4 -119 17 -3 8 2 52 11 97 9 45 16 93 16 108 0 49 1 49
359 47 316 -3 336 -4 339 -21z m1995 -269 c61 -81 178 -205 246 -261 50 -42
48 -50 -21 -85 -61 -30 -103 -66 -94 -80 12 -20 42 -14 132 28 48 22 91 40 96
40 7 0 61 -34 158 -100 14 -9 51 -29 83 -45 32 -15 56 -33 54 -39 -2 -6 -30
-14 -63 -17 -69 -8 -264 -60 -329 -88 -96 -41 -168 -78 -189 -98 -50 -46 -23
-64 50 -33 27 12 62 27 79 34 70 30 94 39 175 66 96 31 262 66 361 76 52 5 80
2 130 -14 149 -47 300 -71 442 -72 79 0 96 -4 164 -35 42 -19 82 -35 89 -35
21 0 27 20 14 45 -19 36 -7 51 52 65 29 6 78 22 109 36 31 13 63 24 72 24 17
0 17 0 47 -185 11 -71 30 -185 41 -252 25 -152 21 -164 -45 -120 -42 29 -224
87 -381 121 -303 66 -724 69 -975 6 -41 -10 -95 -23 -120 -29 -45 -9 -126 -35
-165 -51 -102 -43 -221 -99 -270 -128 -55 -31 -200 -140 -222 -166 -15 -17
-28 -23 -39 -19 -15 5 -16 19 -11 107 13 244 73 638 146 966 40 180 89 367
101 391 6 10 15 19 19 19 5 0 33 -33 64 -72z m2595 -629 c382 -386 381 -385
351 -442 -25 -45 -106 -92 -144 -83 -33 8 -720 717 -720 742 0 19 126 155 140
152 6 -2 173 -168 373 -369z m-6912 346 c8 -20 -11 -75 -67 -191 -52 -109
-106 -175 -178 -219 -37 -23 -52 -27 -97 -23 -119 10 -177 95 -208 304 -10 68
0 74 160 88 78 7 146 16 153 20 6 4 57 13 114 21 56 7 106 13 110 14 4 0 10
-6 13 -14z m5522 -785 c221 -24 496 -84 599 -132 70 -32 123 -76 123 -101 -1
-40 -25 -60 -63 -53 -19 4 -40 13 -47 21 -7 8 -18 15 -24 15 -6 0 -23 6 -38
14 -24 13 -140 50 -283 91 -95 28 -221 46 -365 55 -152 9 -329 3 -352 -11 -28
-19 18 -26 205 -32 193 -6 423 -38 525 -73 23 -7 52 -14 62 -14 11 0 28 -4 38
-10 15 -8 219 -88 265 -103 9 -4 17 -12 17 -20 0 -14 -47 -117 -54 -117 -7 0
-91 30 -111 40 -38 18 -130 52 -190 70 -171 51 -234 68 -275 73 -25 3 -83 13
-130 23 -62 12 -145 17 -310 18 -200 1 -238 -2 -340 -23 -129 -26 -225 -54
-285 -81 -22 -10 -70 -32 -108 -49 -102 -47 -206 -129 -266 -210 -40 -54 -59
-71 -77 -71 -29 0 -29 6 -5 62 25 57 110 150 180 196 60 40 169 92 193 92 8 0
23 6 33 14 18 13 18 14 -4 25 -22 12 -67 8 -101 -9 -8 -5 -42 -21 -74 -37
-101 -48 -242 -193 -271 -278 -15 -44 -50 -46 -68 -3 -16 38 -118 138 -141
138 -26 0 -19 -19 28 -73 67 -80 82 -117 48 -117 -10 0 -50 34 -88 75 -129
141 -291 224 -539 278 -68 14 -146 20 -319 24 -393 9 -665 -33 -916 -140 -44
-19 -62 -10 -91 48 -27 55 -24 60 64 93 230 87 351 105 692 106 203 1 283 -3
366 -16 131 -22 158 -22 166 -2 9 25 -7 32 -107 52 -113 23 -196 27 -485 26
-323 -2 -500 -35 -699 -130 -45 -22 -52 -18 -90 45 -55 90 -52 95 52 120 49
11 120 25 158 31 38 6 89 15 114 20 198 40 656 49 830 16 52 -10 118 -22 145
-27 109 -19 289 -85 430 -156 125 -63 337 -217 371 -269 27 -40 51 -30 143 59
48 46 122 107 165 136 76 51 265 151 287 151 5 0 28 9 50 20 64 30 305 89 430
104 140 17 407 20 537 6z m-4975 -347 c54 -29 129 -52 202 -64 39 -5 95 -16
125 -24 30 -7 93 -19 140 -25 126 -17 123 -16 116 -58 -20 -119 -24 -181 -16
-246 14 -107 18 -100 -47 -92 -72 8 -239 40 -358 67 -116 27 -165 56 -201 116
-26 44 -28 58 -32 168 -4 118 5 175 28 175 6 0 25 -8 43 -17z m4235 -7 c2 -10
-3 -25 -11 -34 -8 -9 -18 -28 -22 -42 -21 -71 -585 -1206 -658 -1325 -21 -33
-43 -69 -50 -80 -28 -46 -111 -155 -119 -155 -14 0 -46 42 -51 68 -5 25 27
102 59 142 14 17 161 266 207 350 16 30 36 62 43 71 17 19 18 45 2 55 -14 9
-68 -55 -123 -148 -120 -203 -188 -299 -202 -284 -8 8 15 129 32 171 7 17 21
50 31 75 11 24 40 69 67 99 26 30 47 59 47 64 0 6 6 18 14 26 13 14 37 59 167
300 51 96 58 109 67 129 11 21 32 62 44 82 11 21 74 139 131 250 77 147 80
150 182 179 61 17 119 29 130 27 6 -2 12 -10 13 -20z m874 -20 c126 -33 169
-48 177 -65 5 -9 26 -79 46 -156 82 -311 145 -459 240 -561 44 -48 57 -56 110
-67 98 -20 1450 -12 1765 10 317 22 360 22 373 2 5 -9 7 -28 3 -42 -5 -20 -16
-29 -44 -36 -20 -6 -190 -17 -377 -26 -187 -8 -524 -24 -750 -35 -681 -32
-923 -41 -1085 -43 -148 -2 -157 -1 -204 23 -68 35 -78 57 -176 380 -21 67
-126 469 -140 530 -4 19 -11 43 -15 53 -8 20 0 47 14 47 6 0 34 -6 63 -14z
m-2197 -82 c16 -12 17 -18 7 -32 -6 -9 -21 -35 -33 -57 -12 -22 -24 -42 -28
-45 -3 -3 -14 -21 -24 -40 -26 -51 -80 -145 -93 -161 -6 -8 -15 -24 -18 -36
-4 -13 -12 -23 -17 -23 -41 0 8 180 87 319 49 86 79 105 119 75z m-2101 -53
c256 -36 659 -78 1016 -106 107 -9 199 -20 204 -25 7 -7 4 -32 -7 -74 -20 -75
-22 -215 -5 -281 8 -30 9 -48 2 -55 -9 -9 -392 13 -434 25 -8 2 -64 9 -125 15
-60 6 -153 18 -205 26 -392 61 -571 93 -585 105 -26 19 -47 128 -41 206 8 124
19 183 32 183 4 0 71 -9 148 -19z m2209 -3 c20 -32 -221 -476 -269 -495 -18
-7 -44 14 -44 37 0 10 15 40 33 66 18 27 36 56 40 64 4 8 18 33 32 55 13 22
31 54 40 70 23 46 95 177 112 203 16 26 40 26 56 0z m5097 4 c0 -10 -10 -28
-22 -40 -25 -22 2 -20 -453 -43 -305 -15 -370 -22 -370 -39 0 -13 32 -15 235
-13 129 0 300 5 380 11 80 5 149 6 154 2 4 -5 1 -40 -8 -78 -9 -39 -16 -84
-16 -100 0 -61 -4 -62 -250 -73 -124 -5 -324 -11 -445 -14 -121 -2 -368 -8
-550 -14 -181 -6 -434 -14 -561 -17 -227 -6 -276 -13 -244 -34 17 -12 625 -7
1195 8 204 6 480 12 615 14 l245 3 0 -30 c0 -30 0 -30 -70 -37 -77 -8 -664
-34 -1090 -48 -148 -5 -477 -10 -731 -10 -371 0 -464 3 -479 14 -16 12 -18 23
-12 111 3 54 10 102 15 107 9 9 522 16 1388 18 261 0 283 4 269 42 -5 14 -102
15 -809 10 -629 -4 -805 -2 -811 7 -9 15 54 109 99 149 l31 27 210 3 c262 3
1173 40 1670 67 127 6 272 13 323 14 83 1 92 -1 92 -17z m-5458 -118 c4 -3 0
-21 -8 -40 -20 -48 -44 -167 -44 -220 0 -25 10 -68 21 -95 13 -29 18 -53 13
-58 -12 -10 -176 -31 -246 -31 l-56 0 -20 48 c-40 94 -37 248 8 349 l19 42
123 4 c68 1 137 4 154 5 17 1 33 -1 36 -4z m-419 -49 c-1 -22 -5 -93 -9 -157
-4 -76 -3 -132 5 -162 15 -62 8 -76 -43 -76 -63 0 -89 18 -103 70 -26 102 -7
338 30 362 7 5 37 7 67 6 l55 -3 -2 -40z m-2162 -504 c76 -35 289 -85 484
-112 39 -6 74 -14 79 -19 4 -5 4 -73 -2 -157 -6 -81 -8 -177 -4 -213 12 -110
13 -110 -103 -84 -38 8 -119 24 -180 34 -290 51 -351 88 -393 237 -35 128 -12
343 38 343 10 0 46 -13 81 -29z m846 -165 c383 -53 1060 -124 1435 -151 49 -4
90 -10 93 -15 2 -4 -3 -32 -12 -61 -22 -68 -24 -317 -4 -397 8 -30 10 -57 5
-62 -18 -17 -634 50 -1019 111 -71 11 -170 26 -220 34 -49 8 -153 26 -230 40
-77 14 -158 29 -180 32 -54 8 -71 25 -86 86 -18 78 -6 363 17 388 9 10 18 19
20 19 1 0 83 -11 181 -24z m6733 -56 c0 -19 -23 -59 -38 -65 -8 -3 -115 -10
-236 -15 -381 -17 -507 -28 -536 -48 -25 -17 -25 -17 45 -20 39 -2 167 1 286
7 119 6 260 11 314 11 l97 0 -6 -32 c-3 -18 -11 -69 -17 -113 -6 -44 -16 -83
-23 -87 -6 -4 -33 -8 -61 -9 -84 -1 -241 -8 -430 -18 -99 -5 -376 -13 -615
-16 -699 -11 -842 -18 -895 -48 -29 -16 -25 -17 140 -17 94 0 314 5 490 10
176 5 430 10 565 11 135 2 373 8 530 14 183 8 289 8 298 2 19 -15 14 -45 -9
-57 -12 -7 -187 -19 -432 -30 -708 -33 -977 -40 -1454 -40 -420 0 -463 2 -478
17 -23 23 -17 168 9 207 l17 27 202 -7 c300 -10 1418 14 1436 31 37 36 18 37
-790 31 -783 -6 -829 -5 -829 25 0 15 73 106 105 131 23 18 43 21 203 24 322
7 1818 68 1907 78 72 7 205 5 205 -4z m-4370 -114 c0 -14 -4 -27 -8 -30 -20
-12 -37 -127 -36 -246 0 -111 3 -130 24 -168 30 -57 19 -67 -83 -81 -90 -13
-386 -15 -404 -3 -25 16 -45 98 -50 203 -6 117 7 213 37 284 l19 45 173 1 c95
0 196 4 223 9 94 14 105 13 105 -14z m-594 -10 c3 -8 -2 -38 -11 -67 -22 -74
-29 -207 -16 -314 20 -155 23 -140 -36 -143 -67 -4 -88 8 -115 66 -18 38 -22
70 -26 173 -4 132 6 211 35 267 17 32 18 32 91 32 53 0 74 -4 78 -14z"
          fill="currentColor"
        />
        <path
          d="M6375 10914 c-6 -2 -44 -7 -85 -12 -57 -5 -75 -11 -75 -22 0 -13 46
-16 325 -22 179 -4 379 -10 445 -14 66 -5 165 -8 220 -9 96 0 100 1 103 23 2
12 0 22 -5 23 -373 27 -898 46 -928 33z"
          fill="currentColor"
        />
        <path
          d="M5669 12306 c-2 -2 -94 -9 -204 -15 -287 -17 -409 -30 -435 -46 -24
-15 -10 -34 23 -30 17 3 147 9 287 15 460 19 493 23 477 64 -5 13 -21 16 -75
16 -38 0 -71 -2 -73 -4z"
          fill="currentColor"
        />
        <path
          d="M5405 12079 c-180 -8 -362 -25 -389 -35 -9 -4 -16 -14 -14 -23 4 -19
0 -19 571 -4 315 9 371 12 384 26 13 13 14 19 3 31 -10 14 -42 16 -204 14
-105 0 -263 -5 -351 -9z"
          fill="currentColor"
        />
        <path
          d="M5550 11844 c-25 -2 -155 -8 -290 -15 -223 -10 -270 -17 -270 -39 0
-14 105 -23 220 -19 63 2 217 3 343 1 221 -2 227 -2 227 18 0 11 -10 26 -22
34 -24 15 -132 25 -208 20z"
          fill="currentColor"
        />
        <path
          d="M10480 11579 c-274 -82 -411 -135 -407 -159 3 -18 43 -26 60 -12 7 6
39 17 72 25 33 9 107 30 165 47 58 18 129 39 157 48 58 16 78 33 69 57 -7 20
-36 18 -116 -6z"
          fill="currentColor"
        />
        <path
          d="M10545 11408 c-16 -5 -43 -16 -60 -23 -16 -7 -46 -16 -65 -20 -19 -4
-39 -11 -45 -15 -5 -5 -30 -13 -55 -19 -25 -7 -54 -16 -65 -22 -11 -5 -40 -15
-65 -22 -34 -10 -46 -18 -48 -35 -2 -16 2 -22 15 -22 19 0 185 46 218 60 11 5
31 12 45 15 14 4 65 20 113 37 76 27 88 34 85 52 -3 24 -29 29 -73 14z"
          fill="currentColor"
        />
        <path
          d="M4640 9329 c-36 -10 -99 -28 -140 -38 -151 -40 -197 -53 -317 -92
-67 -21 -129 -39 -136 -39 -8 0 -40 -11 -71 -25 -63 -28 -74 -57 -24 -63 27
-3 217 45 288 73 19 7 78 25 130 40 52 15 133 38 180 52 47 13 109 30 138 36
54 12 79 35 68 63 -7 18 -35 16 -116 -7z"
          fill="currentColor"
        />
        <path
          d="M4405 8978 c-33 -11 -123 -40 -201 -64 -118 -37 -143 -48 -154 -70
-18 -34 2 -49 39 -29 14 7 42 16 61 20 19 4 54 16 77 26 23 11 48 19 57 19 8
0 38 9 68 19 29 10 73 25 98 32 53 15 75 36 59 56 -14 16 -29 15 -104 -9z"
          fill="currentColor"
        />
        <path
          d="M4730 8797 c-192 -65 -309 -100 -445 -137 -130 -36 -185 -60 -185
-81 0 -11 9 -21 24 -25 25 -6 211 35 276 61 19 8 60 21 90 29 30 8 69 19 85
25 17 6 102 34 190 62 88 28 170 57 183 65 37 24 23 66 -21 63 -7 0 -95 -29
-197 -62z"
          fill="currentColor"
        />
        <path
          d="M5050 8544 c-41 -14 -106 -34 -145 -46 -38 -11 -86 -27 -105 -34 -19
-7 -55 -18 -80 -24 -25 -6 -63 -17 -85 -25 -22 -7 -76 -23 -120 -35 -129 -37
-238 -71 -272 -86 -17 -8 -38 -14 -46 -14 -20 0 -40 -27 -33 -45 3 -8 13 -15
23 -15 24 0 240 55 333 85 110 35 253 80 355 110 233 70 280 89 283 114 3 20
-12 42 -28 40 -3 0 -39 -12 -80 -25z"
          fill="currentColor"
        />
        <path
          d="M5095 8203 c-58 -12 -537 -127 -580 -139 -27 -8 -72 -19 -100 -24
-140 -29 -190 -46 -190 -66 0 -17 7 -19 61 -17 33 1 139 20 235 43 96 23 201
48 234 56 33 7 130 30 215 49 172 39 210 52 210 69 0 30 -32 41 -85 29z"
          fill="currentColor"
        />
        <path
          d="M5055 7869 c-66 -17 -151 -38 -190 -48 -38 -10 -187 -46 -330 -81
-294 -71 -335 -85 -335 -112 0 -29 21 -31 117 -9 48 11 133 29 188 42 96 21
533 131 662 166 63 18 77 30 67 58 -8 21 -41 18 -179 -16z"
          fill="currentColor"
        />
        <path
          d="M5135 7618 c-33 -11 -103 -37 -155 -58 -98 -39 -163 -62 -240 -84
-25 -7 -55 -18 -65 -23 -11 -6 -105 -32 -210 -57 -250 -61 -287 -74 -283 -101
3 -18 9 -20 63 -18 54 2 248 43 298 63 12 5 65 21 117 36 325 94 563 187 575
225 14 43 -10 47 -100 17z"
          fill="currentColor"
        />
        <path
          d="M8905 9584 c-221 -32 -329 -71 -450 -163 -61 -46 -175 -165 -175
-183 0 -5 -11 -24 -24 -41 -30 -42 -81 -166 -97 -242 -16 -76 -18 -349 -2
-430 13 -66 47 -189 62 -220 35 -75 61 -135 61 -140 0 -3 16 -31 35 -61 19
-30 35 -57 35 -60 0 -3 33 -49 73 -102 70 -93 241 -274 302 -320 77 -57 155
-112 161 -112 3 0 18 -9 33 -19 41 -29 184 -101 201 -101 9 0 20 -4 25 -9 33
-32 264 -85 420 -96 153 -10 391 38 477 97 14 10 32 18 39 18 27 0 185 142
239 215 50 68 108 190 132 278 26 94 36 331 18 420 -37 184 -96 339 -191 497
-53 89 -170 229 -279 333 -243 235 -495 369 -790 423 -81 15 -257 25 -305 18z
m348 -164 c31 -11 62 -20 68 -20 6 0 25 -6 42 -14 18 -8 61 -27 97 -42 36 -15
72 -33 80 -40 8 -6 38 -23 67 -38 28 -14 61 -38 73 -53 l22 -28 -89 -3 c-105
-4 -152 7 -258 58 -161 77 -192 84 -370 85 -88 0 -166 4 -172 8 -7 5 -13 16
-13 25 0 9 -12 27 -27 39 -27 22 -28 23 -8 38 30 24 407 12 488 -15z m-238
-145 c101 -9 224 -42 258 -71 l29 -24 -241 0 c-227 0 -240 1 -246 19 -8 27 4
69 24 81 9 5 36 7 61 5 25 -2 77 -7 115 -10z m510 -190 c28 -20 71 -50 98 -67
34 -22 47 -37 47 -55 l0 -23 -717 2 -718 3 -3 26 c-2 15 3 42 11 61 l15 35
169 6 c133 5 182 10 224 26 50 18 83 19 439 20 l385 1 50 -35z m363 -37 c88
-86 85 -98 -23 -98 l-73 0 -72 60 c-39 33 -75 60 -78 60 -4 0 -15 7 -26 15
-34 26 -8 35 97 35 l102 0 73 -72z m-130 -162 c15 -8 44 -32 66 -54 71 -74 84
-72 -411 -71 -241 1 -611 5 -823 8 l-385 6 -3 42 c-2 23 2 51 8 63 11 20 16
20 766 20 632 0 759 -2 782 -14z m312 -38 c66 -69 63 -82 -20 -86 -89 -4 -100
0 -143 56 -56 74 -52 82 38 82 l75 0 50 -52z m-146 -153 c24 -26 62 -102 54
-110 -2 -2 -36 -7 -75 -11 -51 -5 -84 -2 -119 9 -161 50 -232 60 -449 59 -115
0 -226 -3 -245 -5 -117 -17 -347 -75 -406 -102 -38 -18 -130 -21 -321 -10
l-143 8 -10 36 c-11 41 -13 134 -3 144 3 4 386 7 850 7 l844 0 23 -25z m236
12 c26 -20 62 -87 56 -102 -4 -11 -22 -15 -65 -15 -77 0 -85 4 -121 57 -33 49
-36 59 -17 66 25 11 132 6 147 -6z m-630 -127 c137 -20 316 -71 352 -100 24
-19 25 -23 31 -192 6 -183 49 -529 98 -782 8 -43 7 -52 -11 -71 -43 -46 -280
-102 -280 -65 0 25 -54 60 -131 83 -146 45 -245 60 -439 66 l-185 7 -65 44
c-172 118 -186 134 -132 145 15 3 52 12 82 20 105 26 292 47 380 42 116 -7
295 -33 320 -47 31 -16 84 -9 88 13 5 26 -49 45 -202 70 -212 35 -472 22 -674
-33 -40 -11 -81 -20 -91 -20 -20 0 -141 126 -141 147 0 13 49 43 70 43 7 0 26
7 43 15 221 102 563 137 830 85 120 -23 147 -21 134 13 -6 17 -116 46 -222 59
-138 16 -403 2 -525 -27 -149 -37 -308 -98 -325 -125 -14 -22 -53 -10 -80 26
-54 70 -135 218 -135 246 0 33 54 71 235 163 123 63 160 78 300 119 223 66
469 86 675 56z m737 -72 c4 -7 14 -29 21 -48 70 -185 91 -419 52 -582 -26
-110 -72 -213 -128 -287 -40 -52 -85 -91 -108 -91 -7 0 -14 27 -18 63 -4 34
-13 98 -21 142 -25 137 -56 423 -65 590 -5 88 -12 172 -15 188 -6 22 -4 27 11
27 11 0 25 -4 32 -9 20 -12 79 -190 97 -289 16 -95 20 -283 6 -310 -5 -9 -10
-42 -12 -72 -4 -50 -2 -55 18 -58 18 -3 22 3 28 40 4 24 15 57 23 73 13 24 16
62 16 190 -1 136 -4 169 -23 224 -11 35 -21 68 -21 73 0 5 -11 34 -25 64 -29
62 -30 70 -12 77 27 11 136 7 144 -5z m-1773 -31 c25 -10 14 -21 -51 -52 -32
-16 -74 -41 -94 -57 -20 -15 -43 -28 -51 -28 -16 0 -35 29 -53 80 -13 38 -10
54 13 61 20 6 218 3 236 -4z m861 -1033 c164 -27 260 -55 269 -80 3 -8 12 -14
21 -14 8 0 15 -5 15 -10 0 -6 -10 -8 -22 -5 -13 2 -70 10 -128 15 -128 14
-260 45 -320 77 -25 12 -51 23 -57 23 -7 0 -13 5 -13 10 0 12 105 5 235 -16z"
          fill="currentColor"
        />
        <path
          d="M9149 8361 c-42 -5 -91 -13 -110 -19 -19 -6 -56 -14 -84 -18 -27 -3
-55 -10 -61 -15 -5 -5 -38 -15 -73 -23 -34 -8 -68 -19 -74 -24 -7 -5 -28 -13
-47 -17 -19 -4 -39 -11 -45 -15 -5 -4 -30 -14 -55 -21 -43 -12 -70 -32 -70
-52 0 -13 85 -1 121 17 16 8 43 18 61 21 18 4 42 12 53 18 53 29 303 86 426
97 111 10 271 -1 349 -24 71 -21 115 -18 115 8 0 47 -308 87 -506 67z"
          fill="currentColor"
        />
        <path
          d="M6935 8393 c-100 -21 -166 -38 -200 -53 -22 -9 -48 -20 -57 -23 -10
-4 -18 -13 -18 -22 0 -20 62 -20 118 -1 64 23 244 46 357 46 114 0 302 -23
380 -46 147 -45 185 -58 260 -94 87 -42 119 -49 128 -26 23 59 -224 162 -507
211 -82 14 -406 20 -461 8z"
          fill="currentColor"
        />
        <path
          d="M6906 8079 c-55 -5 -113 -13 -129 -19 -17 -5 -45 -10 -63 -10 -45 0
-86 -20 -82 -39 3 -13 16 -15 63 -13 33 1 83 7 111 13 79 15 328 16 424 0 87
-14 230 -52 287 -77 17 -8 36 -14 42 -14 7 0 46 -18 88 -40 98 -51 145 -53
127 -5 -7 17 -94 71 -149 91 -115 44 -240 80 -305 89 -30 3 -68 10 -85 15 -46
13 -219 17 -329 9z"
          fill="currentColor"
        />
        <path
          d="M6707 7769 c-38 -4 -89 -14 -115 -23 -26 -8 -58 -18 -72 -21 -39 -8
-54 -21 -46 -40 5 -14 14 -16 49 -11 23 4 65 14 92 24 74 25 411 24 510 -2
143 -37 259 -79 315 -116 35 -22 98 -42 110 -35 20 12 9 43 -24 69 -19 14 -37
26 -40 26 -3 0 -31 12 -63 26 -32 14 -67 29 -78 34 -51 22 -197 61 -265 70
-87 11 -275 11 -373 -1z"
          fill="currentColor"
        />
        <path
          d="M6620 7455 c-154 -21 -289 -55 -300 -76 -7 -12 -5 -21 6 -30 13 -10
24 -10 62 1 26 7 69 19 96 26 84 23 294 36 411 24 222 -21 468 -102 591 -195
30 -23 46 -29 72 -26 18 2 15 46 -5 63 -55 49 -224 126 -373 170 -171 50 -385
67 -560 43z"
          fill="currentColor"
        />
        <path
          d="M6515 7149 c-22 -5 -71 -15 -110 -23 -117 -24 -180 -50 -183 -74 -4
-28 15 -28 96 -3 33 11 112 27 175 36 103 14 128 14 248 1 74 -9 156 -23 182
-32 74 -25 93 14 24 48 -73 36 -346 66 -432 47z"
          fill="currentColor"
        />
        <path
          d="M4714 6090 c-25 -10 -54 -47 -54 -69 0 -8 18 -31 40 -53 35 -32 48
-38 85 -38 105 0 144 109 55 155 -32 16 -92 19 -126 5z"
          fill="currentColor"
        />
        <path
          d="M4711 5211 c-44 -42 -43 -83 6 -127 45 -41 80 -44 139 -9 67 40 74
84 21 143 -17 18 -31 22 -78 22 -49 0 -61 -4 -88 -29z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export { EmptyIcon };
